module.exports = __webpack_public_path__ + "img/0220810085323.71784fc8.png";